import {
  ADMIN_ANNOUNCEMENT_DETAILS,
  AdminHeader,
  AdminSpinner,
  Announcement,
  Button,
  Div,
  HeaderIconWrapper,
  PlusIcon,
  SearchInput,
} from '@vgrubs/components';
import { useState } from 'react';
import { generatePath, useNavigate } from 'react-router';
import { NoDataComponent } from '../../adminComponents/NoDataComponent/NoDataComponent';
import { AnnouncementDeleteModal } from './components/AnnouncementDeleteModal';
import { AnnouncementFilters } from './components/AnnouncementFilters';
import { AnnouncementFormModal } from './components/AnnouncementFormModal';
import { AnnouncementListItem } from './components/AnnouncementListItem';
import { useAnnouncementsList } from './hooks/useAnnouncementsList';

export const Announcements = () => {
  const navigate = useNavigate();
  const {
    announcements,
    filters,
    updateFilter,
    remove,
    refresh,
    loading,
    hasNextPage,
    fetchNextPage,
  } = useAnnouncementsList();

  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState<Announcement | null>(null);
  const [pendingDelete, setPendingDelete] = useState<number | null>(null);

  const openForm = (announcement: Announcement | null) => {
    setEditing(announcement);
    setFormOpen(true);
  };

  const confirmDelete = async (id: number) => {
    setPendingDelete(null);
    await remove(id);
  };

  return (
    <>
      <AdminHeader title="Announcements">
        <Div $flex $alignCenter $gap="20px" $gapSM="10px">
          <HeaderIconWrapper onClick={() => openForm(null)}>
            <PlusIcon />
          </HeaderIconWrapper>
          <SearchInput
            value={filters.query}
            maxWidth="350px"
            maxWidthSM="120px"
            placeholder="Search"
            onChange={(e) => updateFilter('query', e.target.value)}
          />
        </Div>
      </AdminHeader>

      {loading && <AdminSpinner />}

      <AnnouncementFilters filters={filters} onChange={updateFilter} />

      <Div $flex $column $gap="8px">
        {announcements.map((announcement) => (
          <AnnouncementListItem
            key={announcement.id}
            announcement={announcement}
            onOpen={(id) =>
              navigate(
                generatePath(ADMIN_ANNOUNCEMENT_DETAILS, { id: String(id) })
              )
            }
            onEdit={openForm}
            onDelete={setPendingDelete}
          />
        ))}
      </Div>

      {!loading && !announcements.length && (
        <NoDataComponent
          title="No announcements to show"
          heightSM="calc(100vh - 500px)"
        />
      )}

      <Div $flex $justifyCenter $mt="20" $height="45px">
        {hasNextPage && (
          <Button onClick={() => fetchNextPage()}>Load More</Button>
        )}
      </Div>

      <AnnouncementDeleteModal
        announcementId={pendingDelete}
        onClose={() => setPendingDelete(null)}
        onConfirm={confirmDelete}
      />

      <AnnouncementFormModal
        isOpen={formOpen}
        closeModal={() => setFormOpen(false)}
        announcement={editing}
        onSaved={refresh}
      />
    </>
  );
};
